<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24"></a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <!-- <a-button @click="handleExportXls('领用物资清单')" icon="download" type="primary">导出</a-button>
      <a-upload
        :action="importExcelUrl"
        :headers="tokenHeader"
        :multiple="false"
        :showUploadList="false"
        @change="handleImportExcel"
        name="file"
      >
        <a-button icon="import" type="primary">导入</a-button>
      </a-upload>-->
      <!-- 高级查询区域 -->
      <!-- <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query> -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <dev-bpbj-leadout-list-modal @ok="modalFormOk" @save="modalOk" ref="modalForm"></dev-bpbj-leadout-list-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DevBpbjLeadoutListModal from './modules/DevBpbjLeadoutListModal'

  export default {
    name: 'DevBpbjLeadoutListList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      DevBpbjLeadoutListModal
    },
    data () {
      return {
        description: '领用物资清单管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: 'center',
            customRender: function (t, r, index) {
              return parseInt(index) + 1
            }
          },
          {
            title: '备件型号ID(备件基本信息主键id)',
            align: 'center',
            dataIndex: 'bjModelId'
          },
          {
            title: '备件名称',
            align: 'center',
            dataIndex: 'bjName'
          },
          {
            title: '领用数量',
            align: 'center',
            dataIndex: 'count'
          },
          {
            title: '单位',
            align: 'center',
            dataIndex: 'unit'
          },
          {
            title: '单价',
            align: 'center',
            dataIndex: 'price'
          },
          {
            title: '总价',
            align: 'center',
            dataIndex: 'cost'
          },
          {
            title: '出库单ID',
            align: 'center',
            dataIndex: 'leadoutId'
          },
          {
            title: '入库物资ID(入库单)',
            align: 'center',
            dataIndex: 'whrId'
          },
          {
            title: '设备台账id',
            align: 'center',
            dataIndex: 'devId'
          },
          {
            title: '任务来源表',
            align: 'center',
            dataIndex: 'taskTable'
          },
          {
            title: '检修计划ID',
            align: 'center',
            dataIndex: 'repairPlanId'
          },
          {
            title: '运维单位',
            align: 'center',
            dataIndex: 'ywUnit'
          },
          {
            title: '删除状态',
            align: 'center',
            dataIndex: 'delFlag'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            fixed: 'right',
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: '/spareparts/devBpbjLeadoutList/list',
          delete: '/spareparts/devBpbjLeadoutList/delete',
          deleteBatch: '/spareparts/devBpbjLeadoutList/deleteBatch',
          exportXlsUrl: '/spareparts/devBpbjLeadoutList/exportXls',
          importExcelUrl: 'spareparts/devBpbjLeadoutList/importExcel'

        },
        dictOptions: {},
        superFieldList: []
      }
    },
    created () {
      this.getSuperFieldList()
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      }
    },
    methods: {

      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = []
        fieldList.push({ type: 'string', value: 'bjModelId', text: '备件型号ID(备件基本信息主键id)' })
        fieldList.push({ type: 'string', value: 'bjName', text: '备件名称' })
        fieldList.push({ type: 'number', value: 'count', text: '领用数量' })
        fieldList.push({ type: 'string', value: 'unit', text: '单位' })
        fieldList.push({ type: 'number', value: 'price', text: '单价' })
        fieldList.push({ type: 'number', value: 'cost', text: '总价' })
        fieldList.push({ type: 'int', value: 'leadoutId', text: '出库单ID' })
        fieldList.push({ type: 'string', value: 'whrId', text: '入库物资ID(入库单)' })
        fieldList.push({ type: 'string', value: 'devId', text: '设备台账id' })
        fieldList.push({ type: 'string', value: 'taskTable', text: '任务来源表' })
        fieldList.push({ type: 'string', value: 'repairPlanId', text: '检修计划ID' })
        fieldList.push({ type: 'string', value: 'ywUnit', text: '运维单位' })
        fieldList.push({ type: 'int', value: 'delFlag', text: '删除状态' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>
